import React from 'react';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';

import { I18N_BASE } from '../../constants';
import styles from './review.module.css';

export interface AccountClusterPillProps {
  accountId: number | null;
  pendingCount: number;
  testId?: string;
}

export function AccountClusterPill({
  accountId,
  pendingCount,
  testId,
}: AccountClusterPillProps): React.ReactElement | null {
  // Backend's pendingCount includes the event currently being reviewed.
  // The pill copy reads "+N pending on this account" — subtract 1 so the count
  // represents *other* pending events the reviewer hasn't seen yet.
  const otherPendingCount = Math.max(0, pendingCount - 1);

  if (accountId == null || otherPendingCount <= 0) return null;

  const linkTo = `/content-moderation?linkedAccountId=${accountId}`;
  return (
    <span className={styles.clusterPill} data-testid={testId}>
      {I18n.t(`${I18N_BASE}.detail.cluster.pending`, { count: otherPendingCount })}
      <Link className={styles.clusterLink} to={linkTo}>
        {I18n.t(`${I18N_BASE}.detail.cluster.viewAll`)}
      </Link>
    </span>
  );
}

export default AccountClusterPill;
